<template lang="pug" src="./blog-post.pug"></template>

<script>
import Loader from 'components/loader/loader'

export default {
  name: 'BlogPost',
  computed: {
    props () {
      return this.$store.state.sortedBlog[this.$route.params.id]
    }
  },
  components: {
    Loader
  }
}
</script>



// WEBPACK FOOTER //
// blog-post.vue?6e8011d1